import React from 'react';
import { connect } from 'react-redux';

import { setOrientation } from '@reducers/actions';
import { setGroundHeight, setGroundWidth, setGroundDepth } from '@reducers/options/ground/actions';
import {
  setRebarReinforcementActiveBtn
} from '@reducers/selectors/application/actions';
import {
  setReinforcementDepth,
  setReinforcementHeight,
  setReinforcementWidth
} from '@reducers/options/reinforcement/actions';
import { APP_TYPES } from '@config';
import { Tooltip } from '@components/Tippy';
import { setAxisOrientation } from '@reducers/camera/actions';
import { getTooltip } from '../../../../texts/tooltips';
import Scene from '@scene';

const RebarReinforcement = (props) => (
  <div className="list-type RebarReinforcement">
    <ul className="inline-list">
      {props.buttons.map(item => (
        <li key={item.id}>
          <Tooltip content={getTooltip(item.tooltip)}>
            <button
              className={`btn btn-light ${item.id === props.activeBtn && 'ImageButton--active'}`}
              onClick={() => { props.onClick(item); }}
            >
              <span className={item.icon} />
            </button>
          </Tooltip>
        </li>
      ))}
    </ul>
  </div>
);

const mapState = state => ({
  options: state.options,

  buttons: state.selectors.application.rebarButtons.buttons,
  activeBtn: state.selectors.application[APP_TYPES.REBAR_REINFORCEMENT].activeBtn
});

const mapDispatch = dispatch => ({
  onClick: ({ id, config }) => {
    dispatch(setGroundWidth(config.ground.width));
    dispatch(setGroundDepth(config.ground.depth));
    dispatch(setGroundHeight(config.ground.height));
    dispatch(setOrientation(config.orientation));
    dispatch(setReinforcementWidth(config.reinforcement.width));
    dispatch(setReinforcementHeight(config.reinforcement.height));
    dispatch(setReinforcementDepth(config.reinforcement.depth));

    dispatch(setRebarReinforcementActiveBtn(id));

    if (config.camera3D && config.camera2D) {
      const orientation = {
        orientation3D: config.camera3D.orientation,
        orientation2D: config.camera2D.orientation
      };
      dispatch(setAxisOrientation(orientation));
    }
    //VladP: reset the camera after the rebar is changed
    setTimeout(() => Scene.resetCamera());
  }
});

export default connect(mapState, mapDispatch)(RebarReinforcement);



// WEBPACK FOOTER //
// ./src/views/Application/types/RebarReinforcement/index.js